/**
 * 简体中文翻译
 */

import type { TranslationDict } from "../types";

export const zhCN: TranslationDict = {
  messages: {
    continue: "继续",
  },
};
